// Screen width detection
let esol_ico_width = 0;

try {
  esol_ico_width =
    window.innerWidth ||
    document.documentElement.clientWidth ||
    document.body.clientWidth;
} catch (err) {}

// Global config object
const iCreateObject = {
  isSiteInICreateMode: "False".toLowerCase() === "true",
  lang: "en",
  isIe8: false,
  corpHome: "https://apps.guelphhydro.com/AccountOnlineWeb/",
  corpRoot: "/",
  gaTrackingCode: "UA-37508705-1",
  isSiteInLocalDevelopment: "False".toLowerCase() === "true",
  calendarUrl: "",
  isSiteInPreviewMode: "False".toLowerCase() === "true",
  newsFeeds: {},
  isMobile: esol_ico_width <= 767,
  iCreateTheme: "",
  iCreatePageId: "903",
};

// News feeds parsing (currently empty but keeping for compatibility)
const myStringArray = "".split(",");

for (let i = 0; i < myStringArray.length; i++) {
  const mySubstring = myStringArray[i].split("|");
  iCreateObject.newsFeeds[mySubstring[0]] = mySubstring[1];
}

// Force HTTPS if page is HTTPS
try {
  if (document.location.href.toLowerCase().indexOf("https://") === 0) {
    iCreateObject.corpHome = "https://" + iCreateObject.corpHome.substring(8);
  }
} catch (err) {}

// Debug logging (only if local dev)
if (iCreateObject.isSiteInLocalDevelopment) {
  console.log(iCreateObject);
}

function showNAMessage() {
  alert("This function is not available in i:Create.");
}

function PrintScreen() {
  if (iCreateObject.isSiteInICreateMode) {
    showNAMessage();
  } else {
    window.print();
  }
}
